module.exports = "/_next/static/images/bakary-1053910f50632d185ec7ac10abdc1f5a.jpg";